import {api} from "./api";

export const validateToken = async (tk: string) => {
    return api.get(`/user/validateToken?tk=${tk}`)
}

export const login = async (data: any) => {
    return api.post(`/user/login`, data)
}


export const createUser = async (data: any) => {
    return api.post(`/user/`, data)
}

const authApi = {
    validateToken,
    login,
    createUser
}

export default authApi;